// Deterministic cover-gradient selection shared by the bands catalog cards and
// the band page hero avatar, so a band keeps the *same* gradient identity
// everywhere it appears without an avatar image. Seeded by the band's stable
// objectId (falling back to any stable string) — never random.

const COVER_GRADIENT_TOKENS = [
    "var(--cover-a)",
    "var(--cover-b)",
    "var(--cover-c)",
    "var(--cover-d)",
    "var(--cover-e)",
    "var(--cover-f)",
    "var(--cover-g)",
];

export function stableHash(input) {
    const source = String(input || "");
    let hash = 0;
    for (let i = 0; i < source.length; i += 1) {
        hash = (hash << 5) - hash + source.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
}

export function pickCoverGradient(seed) {
    if (!seed) {
        return "var(--cover-neutral)";
    }
    return COVER_GRADIENT_TOKENS[stableHash(seed) % COVER_GRADIENT_TOKENS.length];
}
